<template>
  <el-container>
    <el-header class="fixed-head" v-if="isNav">
      <CommonHeaderGuoJiao />
    </el-header>
    <el-main :class="{nav: isNav}">
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>

import CommonHeaderGuoJiao from '@/views/layout/CommonHeaderGuoJiao.vue';

export default {
  name: 'LayoutGuoJiao',
  data() {
    return {
      isNav: false,
    };
  },
  components: { CommonHeaderGuoJiao },
  created() {
    this.isNav = this.$route.query.nav;
  }
};
</script>

<style scoped lang="less">
.fixed-head {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2001;
  transition: all 0.8s;
  opacity: .96;
}

.el-header {
  height: 80px !important;
  min-width: 1400px;
  background-color: #FFFFFF;
  padding: 0;
}

.el-main {
  padding: 0;
  //padding-top: 80px !important;
  background-color: #ffffff;
  //min-height: calc(100vh - 80px);
  min-height: 100vh;
  margin: 0 auto;
  width: 100%;
  min-width: 1400px
}

.nav {
  padding-top: 80px !important;
  min-height: calc(100vh - 80px) !important;
}

</style>
